export const GET_TRAILS = "GET_TRAILS";
export const GET_TRAIL_BY_ID = "GET_TRAIL_BY_ID";
export const UPDATE_TRAIL = "UPDATE_TRAIL";
export const DELETE_TRAIL = "DELETE_TRAIL";
export const CREATE_TRAIL = "CREATE_TRAIL";
